import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting_/quotes/$quoteId")({
  beforeLoad: ({ params: { quoteId } }) => {
    throw redirect({
      to: "/quotes/$quoteId",
      params: { quoteId },
      search: true,
    })
  },
})
